import type { FaireProductEntity } from "../../entity_types/product";

export const p_n89nwx6fqz: FaireProductEntity = {
  token: "p_n89nwx6fqz",
  type: "product",
  name: "organic newborn going home ribbed set - taupe",
  brandToken: "b_pr9eppffs4",
  brandName: "Bubbo & Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/8fb22bed0e5f9e410e0ef8dfe8903d4f540ddabb34454faf443f2901a83de136.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d59d4f68d1040b4674434002f4dc0b9bfc41b13a59d87bd4ca286bafd446d587.jpeg",
    "https://cdn.faire.com/fastly/1ca0bcb935a2daa3bd3cd8fa48f3e79988dcf7cb1cdf1138c33bba01564bbfa3.jpeg",
    "https://cdn.faire.com/fastly/de3eb0d3550dfe272845a9fe2ad4ccccc3385510cb7433a786820cc8b6c753d3.jpeg",
  ],
  priceDollars: 24,
  description:
    "\nReady to add to your hospital bag to welcome your little cutie.\n\nThe set is thought out to ensure comfort for your little newborn when leaving the hospital or even lounging at home. All sets are packed into a reusable soft canvas drawstring bag for ease when packing for your big day.\n\nThe world outside the womb is cold! This set includes a knotted hat to keep your newborn's head warm, a shirt with built-in cuffs to cover your little one's hands (also prevents them scratching themselves), cuffed pants to ensure feet are warm without worrying about tiny socks falling off and a soft swaddle blanket that can also be used to cover baby's car seat.",
  tags: [],
  msrpDollars: 54,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:24.036Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
